// @flow
import env from '../../environment';
import {getCreator} from '../../http';

import type {Currency, Frequency, StoreTier} from '../../entities';

export type TierDetail = {
  id?: string,
  name: string,
  label: string,
  discount?: string,
  prices: {
    price: string,
    currency: Currency,
  }[],
  frequency: Frequency,
  storeTier: StoreTier,
  type?: 'tier-detail',
};

export const endpoints = Object.freeze({
  // GET_SUBSCRIPTION_INFORMATION: `${env.baseApiUrl}/checkout/admin/subscription/current`,
  // GET_DUE_SUBSCRIPTION: `${env.baseApiUrl}/checkout/admin/subscription/next`,
  GET_SUBSCRIPTION_PRICE: `${env.baseApiUrl}/checkout/admin/subscription/price`,
  GET_SUBSCRIPTION_INTEGRATION_TYPE: `${env.baseApiUrl}/pluto/subscription/integration-setting`,

  //STRIPE INTEGRATION
  GET_STRIPE_SUBSCRIPTION_INFORMATION: `${env.baseApiUrl}/pluto/subscription/stripe`,
  GET_STRIPE_SESSION_CLIENT_SECRET: `${env.baseApiUrl}/pluto/subscription/stripe/pricing-table`,
  GET_BILLING_PORTAL_LINK: `${env.baseApiUrl}/pluto/subscription/stripe/billing-portal`,
});

/* export const getSubscriptionInformationApi = getCreator(
  endpoints.GET_SUBSCRIPTION_INFORMATION
); */

// export const getDueInformationApi = getCreator(endpoints.GET_DUE_SUBSCRIPTION);

export const getSubscriptionPriceApi = getCreator(
  endpoints.GET_SUBSCRIPTION_PRICE
);

export const getSubscriptionIntegrationTypeApi = getCreator(
  endpoints.GET_SUBSCRIPTION_INTEGRATION_TYPE
);

export const getStripeSubscriptionInformationApi = getCreator(
  endpoints.GET_STRIPE_SUBSCRIPTION_INFORMATION
);

export const getStripeSessionClientSecretApi = getCreator(
  endpoints.GET_STRIPE_SESSION_CLIENT_SECRET
);

export const getBillingPortalLinkApi = getCreator(
  endpoints.GET_BILLING_PORTAL_LINK
);
